import React, {
  useState,
  useContext,
  useCallback,
  useRef,
  useEffect
} from "react";
import AlertNotificationBanner from "@/react/components/alertNotificationBanner/AlertNotificationBanner.jsx";
import AuthContext from "@/react/context/authContext.jsx";
import BryntumContext from "@/react/context/bryntumContext.jsx";
import { asyncTasksListing, markAsyncTaskAsSeen } from "@/network/network.jsx";
import { getDescriptionOfBoardiAsysnTask } from "@/other/utils/utils.jsx";
import { processAutoCompletedTasks } from "@/other/utils/asyncTaskUtils.jsx";
import {
  ALERT_TYPES,
  ASYNC_TASK_STATUS
} from "@/other/constants/OtherKeys.jsx";
import MySwivuBoards from "@/react/components/MySwivu/MySwivuBoards.jsx";

const BOARD_INDEPENDENT_ASYNC_TASK_TYPES = [1, 5, 6, 7]; // Corresponds to BOARD_DUPLICATION, DEMO_BOARD_CREATION, BOARD_IMPORT, BOARD_EXPORT
export default function MySwivuPage() {
  const [boardIndependentTasks, setBoardIndependentTasks] = useState([]);
  const { user } = useContext(AuthContext);
  const isMounted = useRef(true);
  const { project, editorHandler, stateProvider, boardManager } = useContext(BryntumContext);
  /** Banner Logic */
    // Todo: All Banner logic should be encapsulated in a separate component as this will cause re-render in the entire page.
  const fetchTasks = useCallback(async () => {
    try {
      const { data: tasks } = await asyncTasksListing();
      if (isMounted.current) {
        const filteredTasks = (tasks || []).filter((task) =>
          BOARD_INDEPENDENT_ASYNC_TASK_TYPES.includes(task.type)
        );
        setBoardIndependentTasks(
          filteredTasks.map((boardIndependendBanner) => {
            return {
              id: boardIndependendBanner.id,
              asyncTask: boardIndependendBanner.id,
              createdAt: boardIndependendBanner.created_at,
              updatedAt: boardIndependendBanner.updated_at,
              type: boardIndependendBanner.type,
              isSeen: boardIndependendBanner.is_seen,
              // The data which is currently used in banner content
              asEntityType: "Board",
              alertType: ALERT_TYPES.AsyncTask,
              title: getDescriptionOfBoardiAsysnTask(
                boardIndependendBanner.meta_data.board_name,
                boardIndependendBanner.type
              ),
              alertTag: "Status",
              description: boardIndependendBanner.status
            };
          })
        );
        let completedTasksPollingList = [];
        completedTasksPollingList = tasks.filter(
          (asyncTask) =>
            asyncTask.status === ASYNC_TASK_STATUS.COMPLETED &&
            !asyncTask.is_retrieved
        );
        processAutoCompletedTasks({ completedTasksPollingList, boardManager });
      }
    } catch (error) {
      console.error("Failed to fetch async tasks:", error);
    }
  }, []);

  const handleCancelTask = async (taskId) => {
    setBoardIndependentTasks((prevTasks) =>
      prevTasks.filter((task) => task.id !== taskId)
    );
    fetchTasks();
  };

  const handleMarkTaskSeen = async (taskId) => {
    try {
      await markAsyncTaskAsSeen(taskId);
      setBoardIndependentTasks((prevTasks) =>
        prevTasks.filter((task) => task.id !== taskId)
      );
      fetchTasks();
    } catch (e) {
      // handle error
    }
  };

  useEffect(() => {
    isMounted.current = true;
    fetchTasks();
    const intervalId = setInterval(() => {
      fetchTasks();
    }, 10000); // Poll every 10 seconds

    return () => {
      isMounted.current = false;
      clearInterval(intervalId);
    };
  }, [fetchTasks]);

  return (
    <>
      {user && (
        <AlertNotificationBanner
          project={project}
          editorHandler={boardManager?.editorHandler || editorHandler}
          stateProvider={stateProvider}
          user={user}
          tasks={boardIndependentTasks}
          isBoardIndependentView={true}
          onCancelTask={handleCancelTask}
          onMarkTaskSeen={handleMarkTaskSeen}
        />
      )}
      <MySwivuBoards />
    </>
  );
}
